import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LocationProvider } from "./contexts/LocationContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Depannage from "./pages/Depannage";
import Installation from "./pages/Installation";
import Zone from "./pages/Zone";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import MentionsLegales from "./pages/MentionsLegales";

function App() {
  return (
    <div className="App">
      <LocationProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/depannage" element={<Depannage />} />
              <Route path="/installation" element={<Installation />} />
              <Route path="/zone" element={<Zone />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LocationProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0F172A",
            color: "#FFFFFF",
            border: "1px solid #1E293B",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
